import { type BuilderCtx, CAP, type Collection } from './shared.ts'
import { sortByStale } from '../filter.ts'

export const buildKidsRow = ({ activities }: BuilderCtx): Collection => ({
	key: 'kids',
	title: 'For the kids',
	activities: activities
		.filter((a) => a.audience.includes('kids'))
		.sort(sortByStale)
		.slice(0, CAP),
	seeAll: { audiences: ['kids'] },
})
